import { render } from "./MultiBuild.vue?vue&type=template&id=7c3039d4"
const script = {}

import "./MultiBuild.vue?vue&type=style&index=0&id=7c3039d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__